module.exports = __webpack_public_path__ + "static/media/mask_surface_water.6316f123.png";